export const JSON = ".json"
export const CONTENT = "./content/json/"
export const INITIAL_MENU = "./content/json/initial-menu.json"